// extracted by mini-css-extract-plugin
module.exports = {"base":"Spinner_base__SAHsV","spinner":"Spinner_spinner__WbmkI"};